import face1 from "assets/images/face-male-1.jpg";
import face3 from "assets/images/face-male-2.jpg";
import face5 from "assets/images/face-male-3.jpg";
import face7 from "assets/images/face-male-4.jpg";

import face2 from "assets/images/face-female-1.jpg";
import face4 from "assets/images/face-female-2.jpg";
import face6 from "assets/images/face-female-3.jpg";
import face8 from "assets/images/face-female-4.jpg";

export default [
  {
    id: 1,
    avatar: face1,
    name: "AdrianYang",
    intro: "i pensieri stretti & il viso sciolto",
    status: "online",
    statusText: "在线",
  },
  {
    id: 2,
    avatar: face2,
    name: "孙文佳",
    intro: "我是一名前端工程师",
    status: "online",
    statusText: "在线",
  },
  {
    id: 3,
    avatar: face3,
    name: "word.execute(me)",
    intro: "Mögen die Macht mit dir sein.",
    status: "offline",
    statusText: "离线",
  },
  {
    id: 4,
    avatar: face4,
    name: "KKkolosov",
    intro: "健康可爱，没有眼袋",
    status: "online",
    statusText: "在线",
  },
  {
    id: 5,
    avatar: face5,
    name: "张峰",
    intro: "在白色雏菊前，剪刀犹豫了半刻",
    status: "online",
    statusText: "在线",
  },
  {
    id: 6,
    avatar: face6,
    name: "李凝",
    intro: "朋友你好~",
    status: "offline",
    statusText: "离线",
  },
  {
    id: 7,
    avatar: face7,
    name: "王雨斐",
    intro: "thank u,next",
    status: "online",
    statusText: "在线",
  },
  {
    id: 8,
    avatar: face8,
    name: "Daniel",
    intro: "you will be what you want to be",
    status: "offline",
    statusText: "离线",
  },
];
